import React, { cloneElement, FC } from "react";
import {
  CreateButton,
  ListButton,
  sanitizeListRestProps,
  TopToolbar,
  Button,
} from "react-admin";
import PermissionIcon from "@material-ui/icons/Accessibility";
import { useHistory } from "react-router";

const ListActions: FC<any> = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  showPermission = false,
  ...rest
}) => {
  const history = useHistory();
  const { data } = rest;
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {!filters && <ListButton basePath={basePath} />}
      {filters &&
        cloneElement(filters, {
          undoable: "false",
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <CreateButton basePath={basePath} />
      {showPermission && (
        <Button
          variant="text"
          label="pos.action.grant"
          onClick={() => {
            history.push(`/permissions/${data.id}`);
          }}>
          <PermissionIcon style={{ fontSize: "20" }} />
        </Button>
      )}
    </TopToolbar>
  );
};

export default ListActions;
